import './src/styles.scss';
import { terminal, getWindow } from './src/terminal.js';

import './src/songs/awakening.mp3'
import './src/songs/bluelights.mp3'
import './src/songs/cuttingedge.mp3'
import './src/songs/cyberwasteland.mp3'
import './src/songs/echoes.mp3'
import './src/songs/electric.mp3'
import './src/songs/erasure.mp3'
import './src/songs/galaxies.mp3'
import './src/songs/goldenhour.mp3'
import './src/songs/init.mp3'
import './src/songs/nighttrip.mp3'
import './src/songs/rush.mp3'

import './src/favicon.ico'

const banner = `
Initializing Distribution System 1.02
Copyright (c) 1984 Retro Propulsion Corp

------------------------------------------------------------
 
    ____       __  
   / __ \\___  / /__________
  / /_/ / _ \\/ __/ ___/ __ \\  
 / _, _/  __/ /_/ /  / /_/ /   
/_/ |_|\\___/\\__/_/   \\____/
            ____                         __     _  
           / __ \\_________  ____  __  __/ /____(_)___  ____ 
          / /_/ / ___/ __ \\/ __ \\/ / / / / ___/ / __ \\/ __ \\
         / ____/ /  / /_/ / /_/ / /_/ / (__  ) / /_/ / / / /
        /_/   /_/   \\____/ .___/\\__,_/_/____/_/\\____/_/ /_/ 
                        /_/ 


------------------------------------------------------------

Ready.

Type 'help' for a list of available commands.
`;

const helpText = `
Available commands:

play - play random song
stop - stop playing music
contact - display contact information
spotify - open spotify profile
bandcamp - open bandcamp profile
instagram - open instagram profile
dir - list files
download - download a file
`;

const songs = [
    "awakening.mp3",
    "bluelights.mp3",
    "cuttingedge.mp3",
    "cyberwasteland.mp3",
    "echoes.mp3",
    "electric.mp3",
    "erasure.mp3",
    "galaxies.mp3",
    "goldenhour.mp3",
    "init.mp3",
    "nighttrip.mp3",
    "rush.mp3"
];

let audio = undefined;

const load = () => {
    const t = terminal({
        prompt: () => `C:\\>`,
        banner,
        commands: {
            help: () => helpText,
            instagram: () => {
                window.location = "https://instagram.com/retro.propulsion";
                return "\nOpening instagram profile"
            },
            spotify: () => {
                window.location = "https://open.spotify.com/artist/4ACAQo1gX0XxM8AVzur7YL?si=H8M6ndHESVmB28L7i-Co5A";
                return "\nOpening spotify profile"
            },
            bandcamp: () => {
                window.location = "https://retropropulsion.bandcamp.com/releases";
                return "\nOpening bandcamp profile"
            },
            contact: () => {
                return "\nEmail: contact@retropropulsion.com\nMessages via instagram also welcome"
            },
            dir: () => {
                return "\n" + songs.join("\n");
            },
            ls: () => {
                return "\n" + songs.join("\n");
            },
            download: (file) => {
                if (!songs.includes(file)) {
                    return "\nFile not found";
                }
                window.location = file;
                return "\nDownloading " + file;
            },
            clear: async (file) => {
                (await t).clear();
                return "\nReady\n";
            },
            play: () => {
                const song = songs[Math.floor(Math.random() * songs.length)];
                if (audio) {
                    audio.pause();
                }
                audio = new Audio(song);
                audio.play();
                return "\nPlaying " + song;
            },
            stop: () => {
                audio.pause();
                return "\nStopped audio";
            },
        }
    });
};

document.addEventListener('DOMContentLoaded', load);
